import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UpdateWidgetCsatRatingRequest } from 'server';
import { appFetch } from './appFetch';
import { widgetKeys } from './keys';

type UpdateCsatRatingParams = {
  isSatisfied: boolean;
  organizationId: string;
  agentId: string;
};

export const useUpdateCsatRating = (chatId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdateCsatRatingParams) => {
      const request: UpdateWidgetCsatRatingRequest = {
        organizationId: params.organizationId,
        agentId: params.agentId,
        isSatisfied: params.isSatisfied
      };
      await appFetch(`/app/public/widget/chats/${chatId}/update-csat-rating`, {
        method: 'POST',
        body: request
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: widgetKeys.chat(chatId) });
    }
  });
};
